export default __webpack_public_path__ + "static/media/pokemon_fire.a6f61c4e.png";